import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

import OutsideHandler from 'components/common/OutsideHandler';

import './TooltipCommon.css';

const TooltipCommon = props => {
  const {
    overlayClassName,
    visible,
    children,
    placement,
    trigger,
    overlay,
    header,
    closeIcon,
    onClose,
    key,
  } = props;

  return (
    <Tooltip
      key={key}
      overlayClassName={`tooltip-common__component${overlayClassName ?
        ` ${overlayClassName}` : ''}`}
      placement={placement || 'top'}
      trigger={trigger || 'hover'}
      visible={visible}
      overlay={
        <OutsideHandler handleClickOutside={onClose}>
          <div className="overlay-block">
            <div className="tooltip-header">
              <div className="header-text">
                {header && header}
              </div>
              {closeIcon &&
              <div
                className="close-icon"
                onClick={onClose}
                role="button"
                tabIndex={-1}
              />
              }
            </div>
            {overlay}
          </div>
        </OutsideHandler>
      }
    >
      {children}
    </Tooltip>
  );
};

TooltipCommon.propTypes = {
  overlayClassName: PropTypes.string,
  visible: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
  placement: PropTypes.string,
  trigger: PropTypes.string,
  overlay: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.string,
  ]).isRequired,
  header: PropTypes.string,
  closeIcon: PropTypes.bool,
  onClose: PropTypes.func,
  key: PropTypes.string,
};

TooltipCommon.defaultProps = {
  overlayClassName: null,
  visible: null,
  placement: null,
  trigger: null,
  header: null,
  closeIcon: null,
  onClose: null,
  key: null,
};

export default TooltipCommon;
